export default __webpack_public_path__ + "static/media/img_13.5b76f56f.JPG";